export default __webpack_public_path__ + "static/media/property_1_19.81175b15.webp";